//core
import React from "react";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

interface IDescriptionItem {
  label: string;
  value: string | number | null;
}

interface IHistoryDescription {
  whiteSpace?: boolean;
  descriptions: IDescriptionItem[];
}

const useStyles = makeStyles({
  text: {
    color: 'inherit',
  },
  whiteSpace: {
    whiteSpace: 'nowrap',
  }
});

const HistoryDescription: React.FC<IHistoryDescription> = ({
  whiteSpace = false,
  descriptions,
}): JSX.Element  => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <span
      className={`${styles.text} ${whiteSpace ? styles.whiteSpace : ''}`}
    >
      {descriptions.map((item, index) => (
        <React.Fragment key={index}>
          {t(item.label)} {item.value ?? '—'}
          {index < descriptions.length - 1 ? ', ' : ''}
        </React.Fragment>
      ))}
    </span>
  );
};

export default HistoryDescription;
